import React from 'react';
import { Button } from 'Common/components/Atoms/Button';
import { Flex } from 'Common/components/Atoms/Flex';
import { Div } from 'Common/components/Atoms/Div';
import { Loading } from 'Common/components/Atoms/Loading';
import { ProviderIcon } from 'Common/components/Molecules/ProviderIcon';
import { Text } from 'Common/components/Atoms/Text';
import {
  displayNameForProvider,
  displayColorForProvider,
} from '../../utils/providerHelpers';
import { useTheme } from '@mui/material/styles';
import { LoginText } from 'DisplayText/Login';
import { Provider } from '../../models/Organization';

interface Props {
  provider: Provider;
  isLoading?: Provider | null;
  onClick: (provider: string) => void;
}

function OAuthButton({ provider, isLoading, onClick }: Props) {
  const theme = useTheme();
  const logoFlexColor =
    provider === 'hackerone'
      ? theme.palette.common.black
      : theme.palette.common.white;

  return (
    <Button
      width="100%"
      mb={2}
      customcolor={displayColorForProvider(provider)}
      onClick={() => onClick(provider)}
      variant="contained"
    >
      {isLoading === provider ? (
        <Flex alignItems="center">
          <Text variant="body1" customcolor={theme.palette.common.white}>
            {LoginText.SYNCING_ACCOUNT}
          </Text>
          <Loading size={16} customcolor={theme.palette.common.white} ml={1} />
        </Flex>
      ) : (
        <Flex alignItems="center" color={logoFlexColor}>
          <ProviderIcon provider={provider} mr={1} color="inherit" />
          <Text variant="h4" color="inherit">
            {LoginText.SIGN_IN_WITH_PROVIDER.replace(
              '{PROVIDER}',
              displayNameForProvider(provider)
            )}
          </Text>
        </Flex>
      )}
    </Button>
  );
}

export default OAuthButton;
